<template>

    <div v-if="list" class="stats-wrapper">

        <chart :legend="legend" class="doughnut" ref="chart" :id="`${slug}-chart`" :result="list" :language="language" />

        <table class="table">

            <thead>
                <tr>
                    <th scope="col">{{ legendname }}</th>
                    <th scope="col">{{ legendvalue }}</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="(value, name, index) in list" :key="index">
                    <td>{{ nameFix(name) }}</td>
                    <td>{{ value }}</td>
                </tr>
            </tbody>

        </table>

    </div>

</template>

<script>

import Chart from "./Chart";

export default {

    components: {
        Chart,
    },

    data() {

        return {
            list : Object
        };

    },

    props: {

        project: Object,

        values: Object,

        legendname : String,

        legendvalue: String,

        slug : String,

        legend : {
            type: Boolean,
            default: false
        },

        language : {
            type: Object,
            default: null
        }

    },

    mounted: function ()  {
        this.updateStats();
    },

    watch: {

        values(newItems, oldItems) {
            if(oldItems !== newItems) {
                this.updateStats();
            }
        },
    },

    methods: {

        updateStats: function() {

            if( this.values.hasOwnProperty(this.slug) ) {
                this.list = this.values[this.slug];
            }

        },

        nameFix: function(name) {

            if( name === '' || name === null ) {
                return '-'
            }

            if( name === 'good' ) {
                return this.language.good
            }

            if( name === 'bad' ) {
                return this.language.bad
            }

            return name
        }

    }
};
</script>

